<template>
  <component :is="componentName" @changeComponet="changeComponet"></component>
</template>
<script>
import managerList from './managerList/index';
import managerDetails from './managerDetails/index';
import { mapQuery } from '@/utils/util';
export default {
  components: {
    managerList,
    managerDetails,
  },
  data() {
    return {
      componentName: 'managerList',
    };
  },
  watch: {
    $route: {
      handler(route) {
        const { componentName } = route.query;
        componentName ? (this.componentName = componentName) : (this.componentName = 'managerList');
      },
      // 深度观察监听
      immediate: true,
      deep: true,
    },
  },
  methods: {
    changeComponet(componentName, query) {
      this.componentName = componentName;
      const url = `/saas/setManager.html${mapQuery({ componentName, ...query })}`;
      this.g_tourl(url, {});
    },
  },
};
</script>
<style lang="scss" scoped></style>
